import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper, TextField, Checkbox, FormControlLabel, Button, DialogTitle, DialogContent, DialogActions, Dialog } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions'
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment'

const styles = theme => ({

});

class SelfPacedCourseAddDialog extends Component {

    state = {
        activeCourse: this.props.course
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ activeCourse: nextProps.course })
    }

    handleSubmit = () => {
        this.props.toggleUnscheduledAddDialog(false)
        this.props.confirmUnscheduledCourse(this.state.activeCourse, this.props.company_id)
        // this.setState({ activeCourse: {course_id: 0}, start: null, end: null })
    }

    handleBack = () => {
        this.props.toggleUnscheduledAddDialog(false)
        // this.setState({ activeCourse: {course_id: 0}, start: null, end: null })
    }

    getDisabled = () => {
        if (this.state.activeCourse.course_id === 0) {
            return true
        }
        return false
    }

    render() {
        const { open } = this.props
        const courseItems = this.props.allCourses.filter(course => course.Unscheduled === 1)
            .map(course => {
                return (
                    <MenuItem key={course.course_id} value={course.course_id}><span>{course.CourseName}</span></MenuItem>
                )
            })

        return (
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.props.toggleUnscheduledAddDialog(false)}
            >
                <DialogContent>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            <FormControl variant="outlined">
                                <InputLabel
                                    ref={ref => {
                                        this.InputLabelRef = ref;
                                    }}
                                    htmlFor="outlined-age-simple"
                                >
                                    Course
                            </InputLabel>
                                <Select
                                    disabled={this.props.course.company_calendar_course_id != 0}
                                    style={{ minWidth: '90px' }}
                                    value={this.state.activeCourse.course_id || 0}
                                    onChange={
                                        //this.props.allCourses.filter(course => course.course_id === e.target.value)[0] || { course_id: 0 } }
                                        (e) => {
                                            this.setState({
                                                activeCourse: {
                                                    ...this.state.activeCourse,
                                                    course_id: e.target.value
                                                }
                                            })
                                        }
                                    }
                                    input={
                                        <OutlinedInput
                                            labelWidth={52}
                                            name="Course"
                                            id="outlined-age-simple"
                                        />
                                    }
                                >
                                    <MenuItem value={0}>
                                        <em>None</em>
                                    </MenuItem>
                                    {courseItems}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <div style={{ minWidth: '200px', paddingTop: '10px' }}>
                                <TextField
                                    variant={'outlined'}
                                    id="datetime-local"
                                    label="Start Date"
                                    type="date"
                                    defaultValue={moment(this.state.activeCourse.start).format('YYYY-MM-DD')}
                                    className={this.props.classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(e) => this.setState({
                                        activeCourse: {
                                            ...this.state.activeCourse,
                                            start: e.target.value
                                        }
                                    })}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            <div style={{ minWidth: '200px', paddingTop: '10px' }}>
                                <TextField
                                    variant={'outlined'}
                                    id="datetime-local"
                                    label="End Date"
                                    type="date"
                                    defaultValue={moment(this.state.activeCourse.end).format('YYYY-MM-DD')}
                                    className={this.props.classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(e) => this.setState({
                                        activeCourse: {
                                            ...this.state.activeCourse,
                                            end: e.target.value
                                        }
                                    })}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            <div style={{ minWidth: '200px', paddingTop: '10px' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            style={{ marginLeft: '6px' }}
                                            checked={(this.state.activeCourse.introCourse === 1 )}
                                            onChange={(e) => this.setState({
                                                activeCourse: {
                                                    ...this.state.activeCourse,
                                                    introCourse: this.state.activeCourse.introCourse === 1 ? 0 : 1
                                                }
                                            })}
                                            color="primary"
                                        />
                                    }
                                    label="Intro Level Course"
                                />
                            </div>
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <div className={'float-left'}>
                        <Button onClick={() => this.handleBack()} variant="contained">
                            Go Back
                        </Button>
                    </div>

                    <div className={'float-right'}>
                        <Button
                            onClick={() => this.handleSubmit()}
                            variant="contained"
                            disabled={this.getDisabled()}
                        >
                            Submit
                        </Button>
                    </div>

                </DialogActions>
            </Dialog>
        )
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleUnscheduledAddDialog: Actions.toggleUnscheduledAddDialog,
        confirmUnscheduledCourse: Actions.confirmUnscheduledCourse,
    }, dispatch)
}

function mapStateToProps({ companyApp }) {
    return {
        addUnscheduledDialog: companyApp.companies.addUnscheduledDialog,
        allCourses: companyApp.companies.allCourses,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(SelfPacedCourseAddDialog)));


// WEBPACK FOOTER //
// src/main/content/company/SelfPacedCourseAddDialog.js